import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'

import API from '../api'
import Modal from 'react-modal'

import FaDots from 'react-icons/fa/ellipsis-h'
import FaExclamation from 'react-icons/fa/exclamation-circle'
import FaClose from 'react-icons/fa/times-circle'
import FaCheck from 'react-icons/fa/check'

import Recaptcha from 'react-google-invisible-recaptcha'

@autobind
class WorkOptions extends Component {
  constructor (props) {
    super(props)
    this.state = {showModal: false, flagMessage: '', posting: false, confirmed: false}
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  handleOpenModal (workdId, lessonIndex) {
    this.setState({showModal: true})
  }

  handleCloseModal () {
    this.setState({showModal: false, flagMessage: '', confirmed: false})
  }

  handleFlagMessage (event) {
    this.setState({flagMessage: event.target.value})
  }

  backToSearch () {
    window.location.href = '/'
  }

  flagWork (recaptchaResponse) {
    this.setState({posting: true})
    let user = this.props.user.id ? `${this.props.user.full_name} - ${this.props.user.id} ${this.props.user.email_identity.email}` : 'Anonymous'
    let school = this.props.user.teacher_type && this.props.user.teacher_type.school ? `${this.props.user.teacher_type.school.title} - ${this.props.user.teacher_type.school.id}` : '-'
    let work = `https://pobble.com/works/${this.props.work.id} - ${this.props.work.id}`
    let reason = `User: ${user}\n
               School: ${school}\n
               Work: ${work}\n
               Message: ${this.state.flagMessage}`
    API.put(`/v3/works/${this.props.work.id}/flag?include=work.flag.data,work.flag.account`, {reason, 'g-recaptcha-response': recaptchaResponse})
      .then(resp => this.setState({posting: false, confirmed: true}))
      .catch(err => err.response.data.status == 400 && alert('Thanks for helping us to keep Pobble safe. We noticed that you are flagging quite a few things. Please get in touch via hello@pobble.com so we can address your concern.'))
  }

  checkCaptchaForFlagging () {
    this.recaptcha.execute()
  }

  onCaptchaResolved () {
    this.flagWork(this.recaptcha.getResponse())
  }

  render () {
    let modalContent = <div className='modal-content'>
      <div className='modal-header'>
        <h4 className='modal-title'>Report this work</h4>
        <span className='modal__close' onClick={this.handleCloseModal}>
          <FaClose />
        </span>
      </div>
      <div className='modal-body'>
        <div className='form-group'>
          <p>We are committed to making Pobble safe and accessible for everyone. If you report this piece of writing, we will immediately hide it from public view. We will review it and if it breaches our Terms of Use, we will remove it from the site completely.</p>
          <label htmlFor='flagMessage'>Please provide a reason for removing this work: <span className='text-danger'>*</span></label>
          <textarea className='form-control' id='flagMessage' onChange={this.handleFlagMessage} rows='5' placeholder='eg. This work uses inappropriate language' />
          <Recaptcha ref={ref => { this.recaptcha = ref }} sitekey={this.props.work.recaptcha_site_key} onResolved={this.onCaptchaResolved} />
        </div>
      </div>
      <div className='modal-footer'>
        <button type='button' className='btn btn-link' onClick={this.handleCloseModal}>Cancel</button>
        <button type='button' className='btn btn-danger' onClick={this.checkCaptchaForFlagging} disabled={this.state.flagMessage === '' || this.state.posting}>Report this work</button>
      </div>
    </div>
    let modalConfirmation = <div className='modal-content'>
      <div className='modal-body text-center'>
        <FaCheck className='workFlagIcon' />
        <p>Thank you for helping us keep Pobble safe. <br />This work has now been hidden from the site.</p>
        <button onClick={this.backToSearch} className='btn btn-primary'>Back to Pobble</button>
      </div>
    </div>

    return (
      <span className='workOptions dropdown__wrapper'>
        <label htmlFor='workOptions'><FaDots /></label>
        <input type='checkbox' id='workOptions' hidden />
        <div className='dropdown__menu'>
          <ul>
            <li>
              <button onClick={this.handleOpenModal}><FaExclamation /> Report this work</button>
            </li>
          </ul>
        </div>
        <Modal isOpen={this.state.showModal} contentLabel='Flag this work' onRequestClose={this.handleCloseModal} overlayClassName='modal fade in' style={{content: {background: 'transparent', border: 'none'}}}>
          <div className={`modal-dialog--dynamic modal-dialog ${this.state.confirmed ? 'modal-dialog--small' : ''}`}>
            {!this.state.confirmed && modalContent}
            {this.state.confirmed && modalConfirmation}
          </div>
        </Modal>
      </span>
    )
  }
}

export default WorkOptions

WorkOptions.propTypes = {
  work: PropTypes.object,
  user: PropTypes.object
}



// WEBPACK FOOTER //
// ./components/work/WorkOptions.js